import { useTranslation } from "react-i18next";
import { Calendar2 } from "iconsax-react";
import { DatePicker } from "@/shared/ui";
import type { RangeValue } from "@/shared/ui/DatePicker/useCalendar";
import type { Locale } from "@/shared/utils";
import { formatDateRange, formatDateLocal } from "../../../utils";

interface Props {
  dateRange: RangeValue;
  onDateRangeChange: (range: RangeValue) => void;
}

export default function ReportsHeader({ dateRange, onDateRangeChange }: Props) {
  const { t, i18n } = useTranslation("ReportsPage");
  const locale = i18n.language as Locale;

  return (
    <div className="flex items-center justify-between pb-4 border-b surface-base-stroke mb-5">
      <h1 className="text-display-xs content-base-primary">{t("title")}</h1>
      <DatePicker
        mode="range"
        value={dateRange}
        onChange={function handleDateRangeChange(v) {
          if (v) onDateRangeChange(v);
        }}
        locale={locale}
        hasPeriodPicker
        isSmall
        icon={<Calendar2 size={16} color="currentColor" />}
        align="right"
        width="min-w-48"
        formatDisplayValue={function formatPeriod(range) {
          if (!range.start || !range.end) return "";
          return formatDateRange(formatDateLocal(range.start), formatDateLocal(range.end));
        }}
      />
    </div>
  );
}
